import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

export const UPDATE_AUDIT_ORDER = gql`mutation auditBulk($userId: String, $orderId: String, $audits: [AuditItemInput]) {
  auditBulk(orderId: $orderId, userId: $userId, audits: $audits) {
    auditResults {
      status
      message
    }
  }
}`

const UpdateAuditOrder = ({ children, ...props }) => {
  return (
    <MutationManager mutation={UPDATE_AUDIT_ORDER} refetchQueries={['getOrderById', 'getOrderItems', 'getPickingInfoBy', 'getPickingFeed']}>
      {({ data, loading, updateFn }) => children({ updateFn, loading, ...props })}
    </MutationManager>
  )
}

UpdateAuditOrder.propTypes = {
  children: PropTypes.any
}

export default UpdateAuditOrder
